'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _soucheUtil = require('@souche-f2e/souche-util');

var _soucheUtil2 = _interopRequireDefault(_soucheUtil);

var _httpRequest = require('@souche-f2e/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _headline = require('./headline');

var _headline2 = _interopRequireDefault(_headline);

var _wx = require('./wx');

var _wx2 = _interopRequireDefault(_wx);

var _eqq = require('./eqq');

var _eqq2 = _interopRequireDefault(_eqq);

var _yyb = require('./yyb');

var _yyb2 = _interopRequireDefault(_yyb);

var _baiduPopularize = require('./baidu-popularize');

var _baiduPopularize2 = _interopRequireDefault(_baiduPopularize);

var _momo = require('./momo');

var _momo2 = _interopRequireDefault(_momo);

var _inmobi = require('./inmobi');

var _inmobi2 = _interopRequireDefault(_inmobi);

var _helper = require('../helper');

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 任务队列数组
var taskArr = [];

// 获取到是哪种宣传类型
var GetType = function GetType(type) {
    var typeArr = [null, _eqq2.default, _yyb2.default, _wx2.default, _headline2.default, _momo2.default, _baiduPopularize2.default, _inmobi2.default];
    try {
        return typeArr[type];
    } catch (e) {
        return null;
    }
};

var initChannel = function initChannel(spm, clickId) {
    _httpRequest2.default.ajax({
        url: _helper2.default.SERVERURL + '/marketapi/marketAdvertiseApi/getListBySpm.json',
        type: 'post',
        data: {
            spm: spm
        }
    }).then(function (res) {
        res = res.data;
        for (var i = 0; i < res.length; i += 1) {
            var channel = GetType(res[i].type);
            if (channel) {
                taskArr.push(channel);
                channel.init(res[i].clientId, clickId);
            }
        }
    });
};

exports.default = {
    init: function init() {
        var urlParams = _soucheUtil2.default.getParams();
        var clickId = urlParams.qz_gdt || urlParams.gdt_vid || urlParams.clickId;
        var spm = urlParams.spm;
        // spm值要符合都是数字的规则
        if (spm && /^\d+\.\d+\.\d+\.\d+$/.test(spm)) {
            initChannel(spm, clickId);
        }
    },
    doStatistics: function doStatistics() {
        for (var i = 0; i < taskArr.length; i += 1) {
            taskArr[i].doStatistics();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/index.js
// module id = FzhE
// module chunks = 11